import { FC } from 'react';
import { Alert, Chip } from '@mui/material';

interface MyChangeRequestsProps {
  changeRequests: any[];
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'APPROVED':
      return '#10b981';
    case 'REJECTED':
      return '#ef4444';
    default:
      return '#f59e0b';
  }
};

export const MyChangeRequests: FC<MyChangeRequestsProps> = ({ changeRequests }) => {
  if (changeRequests.length === 0) return null;

  return (
    <div
      style={{
        marginTop: '24px',
        paddingTop: '24px',
        borderTop: '1px solid #e5e7eb',
      }}
    >
      <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600 }}>My Change Requests</h3>
      <p style={{ margin: '0 0 12px 0', color: '#6b7280', fontSize: '14px' }}>
        Changes you have requested for companies. Approved changes are applied automatically.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {changeRequests.map((cr: any) => {
          return (
            <div
              key={cr.id}
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: 'white',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px',
                }}
              >
                <span style={{ fontWeight: 600, fontSize: '15px' }}>
                  {cr.company?.name || 'Unknown Company'}
                </span>
                <Chip
                  label={cr.status}
                  size="small"
                  sx={{
                    backgroundColor: getStatusColor(cr.status),
                    color: 'white',
                    fontWeight: 600,
                  }}
                />
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>
                Requested: {new Date(cr.createdAt).toLocaleDateString()}
                {cr.reviewedAt && ` · Reviewed: ${new Date(cr.reviewedAt).toLocaleDateString()}`}
              </div>
              {cr.rejectionReason && (
                <Alert severity="error" sx={{ mt: 1 }}>
                  Rejection reason: {cr.rejectionReason}
                </Alert>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
